import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './DateOfBirthEntry.module.sass';
import Select from '../Select';
import Grid from '../Grid';

const DateOfBirthEntry = ({ onChange, classes = {} }) => {
  const [currentMonth, setCurrentMonth] = useState('January');
  const [currentDay, setCurrentDay] = useState(1);
  const [availableDays, setAvailableDays] = useState([]);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const daysInMonths = (month, year) => new Date(year, month, 0).getDate();

  const months = [ "January", "February", "March", "April", "May", "June",
                   "July", "August", "September", "October", "November", "December" ];

  const years = [];
  for (let i = new Date().getFullYear(); i >= 1990; i--) years.push(i);

  useEffect(() => {
    const daysForMonth = [
      ...new Array(daysInMonths(months.indexOf(currentMonth) + 1, currentYear)).keys()
    ].map(key => key + 1);

    if (currentDay > daysForMonth[daysForMonth.length - 1]) setCurrentDay(1);

    setAvailableDays(daysForMonth);
  }, [currentMonth]);

  useEffect(() => {
    onChange(`${currentYear}-${months.indexOf(currentMonth) + 1}-${currentDay}`);
  }, [currentMonth, currentDay, currentYear]);

  return (
    <div>
      <label className={styles.label}>Date of Birth:</label>
      <Grid container spacing={2}>
        <Grid item xs>
          <Select val={currentMonth} onChange={e => setCurrentMonth(e.target.value)}>
            {months.map((month, i) => <option value={month} key={month}>{`${i + 1} - ${month}`}</option>)}
          </Select>
        </Grid>
        <Grid item xs={3}>
          <Select val={currentDay} onChange={e => setCurrentDay(e.target.value)}>
            {availableDays.map(day => <option value={day} key={day}>{day}</option>)}
          </Select>
        </Grid>
        <Grid item xs={4}>
          <Select val={currentYear} onChange={e => setCurrentYear(e.target.value)}>
            {years.map(year => <option value={year} key={year}>{year}</option>)}
          </Select>
        </Grid>
      </Grid>
    </div>
  );
};

DateOfBirthEntry.propTypes = {
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
};

export default DateOfBirthEntry;
